import script from "./TicketNumberBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketNumberBadge.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__